import { RepoCommitTag } from '@/types/schema';
import { useMeasureAndTruncate } from '@/utils/useMeasureAndTruncate';

const CHARACTER_WIDTH = 7;
const X_PADDING = 12;
const RESERVED_WIDTH = 30 + 30; // Approximate width for the overflow button and tag button

export function useVisibleTags(
  tags: RepoCommitTag[],
  containerRef: React.RefObject<HTMLDivElement>,
  activeId?: string
) {
  const { visible, overflow } = useMeasureAndTruncate(tags, containerRef, {
    getCharacterCount: (tag) => tag.tag_name.length,
    characterWidth: CHARACTER_WIDTH,
    additionalPadding: X_PADDING,
    reservedWidth: RESERVED_WIDTH,
    enforceReservedWidth: true,
    elementGap: 0,
    activeElementId: activeId,
    getElementId: (filter) => filter.id,
  });

  return { visibleTags: visible, overflowTags: overflow };
}
